import en from "./language/en_v2.json";
import fa from "./language/fa_v2.json";

export const languageReducer = (state = fa, action) => {
  // console.log(action.payload, "is payload");
  switch (action.type) {
    case "LANGUAGE":
      // 1 is fa
      // 2 is en
      if (action.payload === 1) {
        if (state === fa) {
          // console.log("we are in the second if condition fa");
          state = fa;
          window.document.documentElement.lang = "fa";
          window.document.documentElement.dir = "rtl";
        } else {
          // console.log("we are in the else condition fa");
          state = fa;
          window.document.documentElement.lang = "fa";
          window.document.documentElement.dir = "rtl";
        }
      }
      if (action.payload === 2) {
        if (state === en) {
          // console.log("we are in the second if condition en");
          state = en;
          window.document.documentElement.lang = "en";
        } else {
          // console.log("we are in the else condition en");
          state = en;
          window.document.documentElement.lang = "en";
          window.document.documentElement.dir = "ltr";
        }
      }
      // state = (action.payload===1 && state==fa)? en :fa;
      return state;

    //USER FORM ACTIONS START

    default:
      return state;
  }
};

